import React, { ComponentProps } from 'react'
import Button from 'components/Button'
import Condition from 'components/Condition'
import LoadingIcon from 'components/LoadingIcon'
import Picture from 'components/Picture'
import { FormValueInput, FormValueMeta } from 'types'
import { AddAPhoto } from '@mui/icons-material'
import { useUploadFile } from 'hooks/filestack'
import { Typography } from '@mui/material'
import useStyles from './styles'

interface IScreenshotUploadProps extends ComponentProps<typeof Button> {
  input: FormValueInput<string>
  meta: FormValueMeta
  title?: string
}

export default function ScreenshotUpload(props: IScreenshotUploadProps) {
  const { classes } = useStyles()
  const { input: { value, onChange }, meta: { touched, error }, title, ...otherProps } = props

  const filestack = useUploadFile({
    onChange: file => onChange(file.url),
  })

  const errorText = filestack.error?.message || (touched && error)

  return (
    <div className={classes.container}>
      <Condition condition={Boolean(value)}>
        <Picture src={value} alt="Screenshot" className={classes.image} />
      </Condition>

      <div className={classes.description}>
        <Condition condition={Boolean(title)}>
          <Typography variant="subtitle1" className={classes.title}>
            {title}
          </Typography>
        </Condition>

        <Button
          disabled={filestack.isOpen}
          color="primary"
          className={classes.button}
          onClick={filestack.openPicker}
          startIcon={filestack.isOpen ? <LoadingIcon /> : <AddAPhoto />}
          {...otherProps}
        >
          <span className={classes.buttonLabel}>
            {value ? 'Replace project screenshot' : 'Add project screenshot'}
          </span>
        </Button>

        <Condition condition={Boolean(errorText)}>
          <Typography variant="body2" className={classes.error}>
            {errorText}
          </Typography>
        </Condition>
      </div>
    </div>
  )
}
